import styled from 'styled-components';
import { colors } from 'global/colors';

export const SubHeader = styled.h5`
  margin-top: 1rem;
`;

export const CodeContainer = styled.pre`
  color: ${({ isDarkMode }) => (isDarkMode ? colors.lightGray : colors.darkGray)};
`;
